import gql from 'graphql-tag';
import { ArticleContentFields } from '../content/content.queries';

const ArticleNavItemFields = gql`
	fragment ArticleNavItemFields on ArticleNavItem {
		label
		keyword
	}
`;

export const LEARNING_CENTER_SEARCH = gql`
	${ArticleNavItemFields}
	${ArticleContentFields}

	query ArticleSearch($input: ArticleSearchInput!) {
		articleSearch(input: $input) {
			articles {
				...ArticleContentFields
			}
			rooms {
				...ArticleNavItemFields
			}
			topics {
				...ArticleNavItemFields
			}
			count
		}
	}
`;
